import { REQUESTOR } from 'src/utils/Constants';

export const getBookendHeaderData = async (locale: string, signal?: AbortSignal) => {
  const response = await fetch(
    `https://bookends.cdn.vpsvc.com/v3/vistaprint/${locale}/header/slim?hideVat=undefined&hideSearch=undefined&requestor=${REQUESTOR}`,
    {
      method: 'GET',
      signal,
    }
  );
  return response.json();
};
